var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Navigation',{attrs:{"account-id":_vm.accountId,"news-id":_vm.newsId,"news-details":_vm.newsDetails,"page-size":_vm.pageSize,"template-id":_vm.templateId,"source":_vm.source,"seo":_vm.seo,"seo-base-url":_vm.seoBaseUrl,"autoplay":_vm.autoplay,"enable-a-i":_vm.enableAI,"show-download":_vm.showDownload}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }